function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Instellingen",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Instellingen---Reserveringen-/-Ruimte-reserveringen-3-functioneel-beheerders",
  transform: "translate(-618.000000, -863.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(616.000000, 861.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Invisible_shape",
  x: 0,
  y: 0,
  width: 24,
  height: 24
}), /*#__PURE__*/React.createElement("g", {
  id: "outline",
  transform: "translate(2.000000, 2.000000)",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10,0 C15.5228475,0 20,4.4771525 20,10 C20,15.5228475 15.5228475,20 10,20 C4.4771525,20 0,15.5228475 0,10 C0,4.4771525 4.4771525,0 10,0 Z",
  id: "Oval",
  fill: "#425CD4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10,4.375 C10.3137982,4.375 10.5735831,4.60625788 10.6182234,4.90764208 L10.625,5 L10.625,15 C10.625,15.345178 10.345178,15.625 10,15.625 C9.68620185,15.625 9.42641686,15.3937421 9.3817766,15.0923579 L9.375,15 L9.375,5 C9.375,4.65482203 9.65482203,4.375 10,4.375 Z",
  id: "Path",
  fill: "#FFFFFF",
  transform: "translate(10.000000, 10.000000) rotate(-45.000000) translate(-10.000000, -10.000000) "
}), /*#__PURE__*/React.createElement("path", {
  d: "M15,9.375 C15.345178,9.375 15.625,9.65482203 15.625,10 C15.625,10.3137982 15.3937421,10.5735831 15.0923579,10.6182234 L15,10.625 L5,10.625 C4.65482203,10.625 4.375,10.345178 4.375,10 C4.375,9.68620185 4.60625788,9.42641686 4.90764208,9.3817766 L5,9.375 L15,9.375 Z",
  id: "Path",
  fill: "#FFFFFF",
  transform: "translate(10.000000, 10.000000) rotate(-45.000000) translate(-10.000000, -10.000000) "
})))));
function SvgBlueCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "04_Icons/base/Close2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueCross);
export default __webpack_public_path__ + "static/media/Blue_Cross.8f31165438c4a7f364535880c1031ba7.svg";
export { ForwardRef as ReactComponent };